import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const services = [
    { name: 'Google Ads Management', path: '/services/google-ads' },
    { name: 'Local SEO', path: '/services/local-seo' },
    { name: 'Technical SEO', path: '/services/technical-seo' },
    { name: 'Analytics & Reporting', path: '/services/analytics' },
  ];

  const company = [
    { name: 'About Us', path: '/about' },
    { name: 'Our Process', path: '/process' },
    { name: 'Case Studies', path: '/portfolio' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' },
  ];

  const industries = ['Roofing & Construction', 'HVAC & Plumbing', 'Dental & Healthcare', 'Property Management', 'Legal Services', 'Auto Services'];

  return (
    <footer style={{ background: '#0d0d1a', padding: '60px 24px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 40, marginBottom: 40 }}>
          {/* Brand */}
          <div>
            <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <div style={{ width: 36, height: 36, background: 'linear-gradient(135deg, #ff6b35, #f54e00)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ color: 'white', fontWeight: 800, fontSize: 16 }}>C</span>
              </div>
              <span style={{ fontSize: 18, fontWeight: 700, color: 'white' }}>Crescit Marketing</span>
            </Link>
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14, lineHeight: 1.7, marginBottom: 20 }}>
              Helping local businesses dominate their market through strategic Google Ads and SEO. Real results, no BS.
            </p>
            <div style={{ display: 'flex', gap: 12 }}>
              {['Top Rated Plus', '$500K+ Managed', '50+ Clients'].map((badge, i) => (
                <span key={i} style={{ background: 'rgba(255,107,53,0.2)', color: '#ff6b35', padding: '4px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600 }}>
                  {badge}
                </span>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 style={{ color: 'white', fontSize: 15, fontWeight: 600, marginBottom: 16 }}>Services</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {services.map((item, i) => (
                <li key={i} style={{ marginBottom: 10 }}>
                  <Link to={item.path} style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14, transition: 'color 0.3s' }}
                    onMouseEnter={e => e.target.style.color = '#ff6b35'}
                    onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 style={{ color: 'white', fontSize: 15, fontWeight: 600, marginBottom: 16 }}>Company</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {company.map((item, i) => (
                <li key={i} style={{ marginBottom: 10 }}>
                  <Link to={item.path} style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14, transition: 'color 0.3s' }}
                    onMouseEnter={e => e.target.style.color = '#ff6b35'}
                    onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h4 style={{ color: 'white', fontSize: 15, fontWeight: 600, marginBottom: 16 }}>Industries</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {industries.map((item, i) => (
                <li key={i} style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14, marginBottom: 10 }}>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ color: 'white', fontSize: 15, fontWeight: 600, marginBottom: 16 }}>Contact Us</h4>
            <div style={{ marginBottom: 12 }}>
              <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 12, marginBottom: 4 }}>Email</div>
              <a href="mailto:hello@crescitmarketing.com" style={{ color: 'white', fontSize: 14 }}>hello@crescitmarketing.com</a>
            </div>
            <div style={{ marginBottom: 12 }}>
              <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 12, marginBottom: 4 }}>Phone</div>
              <a href="tel:+15551234567" style={{ color: 'white', fontSize: 14 }}>+1 (555) 123-4567</a>
            </div>
            <div>
              <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 12, marginBottom: 4 }}>Hours</div>
              <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14 }}>Mon-Fri: 9AM - 6PM EST</div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13, margin: 0 }}>
            © 2024 Crescit Marketing. All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: 24 }}>
            <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13, cursor: 'pointer' }}>Privacy Policy</span>
            <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13, cursor: 'pointer' }}>Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
